import axios from "axios";
import React from "react";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import { DEFAULT_ERROR_MESSAGE } from "../../constants/generalConstants";
import {
  NETWORK_ERROR_PAGE_ROUTE,
  NOT_FOUND_ERROR_PAGE_ROUTE,
} from "../../constants/routerConstants";
import { useAlert } from "../../hooks/useAlert";
import JWtUtils from "../../utils/JWtUtils";
import Loading from "../ui/Loading";
import i18n from "../../../i18n";
import { useAuth } from "../../provider";

// Create axios instances for default and authentication specific uses
const instance = axios.create({
  baseURL: config.baseURL,
});

const AxiosInterceptor = ({ children }) => {
  const { showAlert } = useAlert();
  const { toggleLoginDialog } = useAuth();
  const navigate = useNavigate();

  const [isAppReady, setIsAppReady] = React.useState(false);

  const getErrorStatusAndMessage = (error) => {
    const errorStatus =
      error?.response?.data?.status ?? error?.response?.status;
    const errorMessage = error?.response?.data?.message;
    return [errorStatus, errorMessage];
  };

  const handleError = (errorStatus, errorMessage) => {
    if (Boolean(errorStatus)) {
      switch (String(errorStatus)) {
        case "404":
          //navigate(NOT_FOUND_ERROR_PAGE_ROUTE);
          break;
          // case "500":
          //   navigate(SERVER_ERROR_PAGE_ROUTE);
          break;
        case "401":
        case "403":
          if (!JWtUtils.isTokenValidAndNotExpired()) {
            toggleLoginDialog();
          } else {
            showAlert("error", errorMessage ?? DEFAULT_ERROR_MESSAGE);
          }
          break;

        case "301":
          showAlert("warning", errorMessage ?? DEFAULT_ERROR_MESSAGE);
          break;
        case "451":
          break;
        default:
          showAlert("error", errorMessage ?? DEFAULT_ERROR_MESSAGE);
          break;
      }
    } else {
      showAlert("error", errorMessage ?? DEFAULT_ERROR_MESSAGE);
      //navigate(NETWORK_ERROR_PAGE_ROUTE);
    }
  };

  const configuration = (config) => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = localStorage.getItem("authToken");
    const lang = i18n.language || localStorage.getItem("appLang") || urlParams.get("lang") || "en";
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["Accept-Language"] = lang;
    return config;
  };


  React.useEffect(() => {
    instance.interceptors.request.use(configuration);

    const responseInterceptor = (response) => {
      if (response.status > 200 && response.status < 300) {
        showAlert("success", response.data?.message || "Operation successful");
      }
      return response;
    };

    const errorInterceptor = (error) => {
      const [errorStatus, errorMessage] = getErrorStatusAndMessage(error);
      handleError(errorStatus, errorMessage);
      return Promise.reject(error);
    };

    instance.interceptors.response.use(responseInterceptor, errorInterceptor);

    setIsAppReady(true);

    return () => {
      instance.interceptors.request.eject(configuration);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isAppReady ? children : <Loading open={true} />;
};

export { AxiosInterceptor, instance };

export default instance;
